(function () {
  function initHero(root) {
    if (!root) return;
    var track = root.querySelector('.lk-hero__track');
    var items = root.querySelectorAll('.lk-hero__slide');
    var dots = root.querySelectorAll('.lk-hero__dot');
    if (!track || !items.length) return;
    var locked = false;

    function setActive(i) {
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === i);
      });
    }

    track.addEventListener('scroll', function () {
      var h = track.clientHeight;
      setActive(Math.round(track.scrollTop / h));
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ top: i * track.clientHeight, behavior: 'smooth' });
      });
    });

    track.addEventListener(
      'wheel',
      function (e) {
        if (window.innerWidth < 750) return;
        var h = track.clientHeight;
        if (Math.abs(track.scrollTop % h) > 8 && Math.abs(track.scrollTop % h) < h - 8) return;
        if (locked) {
          e.preventDefault();
          return;
        }
        var current = Math.round(track.scrollTop / h);
        var next = current + (e.deltaY > 0 ? 1 : -1);
        if (next >= 0 && next < items.length) {
          e.preventDefault();
          locked = true;
          track.scrollTo({ top: next * h, behavior: 'smooth' });
          setTimeout(function () {
            locked = false;
          }, 750);
        }
      },
      { passive: false }
    );
  }

  function initSlider(root, btnPrev, btnNext) {
    if (!root || root.dataset.lkSliderReady === '1') return;
    root.dataset.lkSliderReady = '1';
    var amount = function () {
      var card = root.querySelector('.lk-review, .lk-explore__card, [data-lk-slide]');
      if (card) return card.getBoundingClientRect().width + 14;
      return Math.min(root.clientWidth * 0.85, 340);
    };
    if (btnPrev)
      btnPrev.addEventListener('click', function () {
        root.scrollBy({ left: -amount(), behavior: 'smooth' });
      });
    if (btnNext)
      btnNext.addEventListener('click', function () {
        root.scrollBy({ left: amount(), behavior: 'smooth' });
      });

    var dragging = false;
    var didDrag = false;
    var startX = 0;
    var startScroll = 0;
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('a, button, input, select, textarea, label')) {
        // Still allow mild drag tracking, but don't capture yet
      }
      dragging = true;
      didDrag = false;
      startX = e.clientX;
      startScroll = root.scrollLeft;
    });
    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!didDrag && Math.abs(dx) < 8) return;
      if (!didDrag) {
        didDrag = true;
        try {
          root.setPointerCapture(e.pointerId);
        } catch (err) {}
      }
      root.scrollLeft = startScroll - dx;
    });
    function endDrag() {
      dragging = false;
    }
    root.addEventListener('pointerup', endDrag);
    root.addEventListener('pointercancel', endDrag);
    root.addEventListener(
      'click',
      function (e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
        }
      },
      true
    );
  }

  function playParaVideo(video) {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;

    var tryPlay = function () {
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          // Retry once media can play (theme editor / slow CDN)
          video.addEventListener(
            'canplay',
            function () {
              video.play().catch(function () {});
            },
            { once: true }
          );
        });
      }
    };

    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('loadeddata', tryPlay, { once: true });
      try {
        video.load();
      } catch (e) {}
    }
  }

  function isParaVideoVisible(video) {
    if (!video) return false;
    var style = window.getComputedStyle(video);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return video.getClientRects().length > 0;
  }

  var paraVideoObserver = null;

  function initParaVideos() {
    var sections = document.querySelectorAll('[data-lk-para]');
    var videos = document.querySelectorAll('[data-lk-para-video]');
    if (!videos.length) return;

    videos.forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
    });

    if (paraVideoObserver) {
      paraVideoObserver.disconnect();
      paraVideoObserver = null;
    }

    if (!sections.length || !('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        if (isParaVideoVisible(video)) playParaVideo(video);
      });
      return;
    }

    paraVideoObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.querySelectorAll('[data-lk-para-video]').forEach(function (video) {
            if (entry.isIntersecting && isParaVideoVisible(video)) {
              if (video.paused) playParaVideo(video);
            } else if (!entry.isIntersecting) {
              video.pause();
            }
          });
        });
      },
      { threshold: [0, 0.05, 0.15], rootMargin: '80px 0px 80px 0px' }
    );

    sections.forEach(function (section) {
      paraVideoObserver.observe(section);
      // Kick playback immediately if already on screen (theme editor / deep link)
      var rect = section.getBoundingClientRect();
      var onScreen = rect.bottom > 40 && rect.top < window.innerHeight - 40;
      if (onScreen) {
        section.querySelectorAll('[data-lk-para-video]').forEach(function (video) {
          if (isParaVideoVisible(video)) playParaVideo(video);
        });
      }
    });
  }

  function boot() {
    document.querySelectorAll('.lk-hero').forEach(initHero);
    document.querySelectorAll('[data-lk-slider]').forEach(function (root) {
      var wrap = root.closest('[data-lk-slider-wrap]') || root.parentElement;
      initSlider(
        root,
        wrap.querySelector('[data-lk-prev]'),
        wrap.querySelector('[data-lk-next]')
      );
    });
    initParaVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', initParaVideos);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') initParaVideos();
  });
})();
